<template>
  <svg focusable="false" aria-hidden="true" class="messenger__arrow" :class="classes">
    <g fill="none">
      <g :style="'fill: '+fillColor">
        <polygon
            transform="translate(-40 -29)translate(47.071068 36.071068)rotate(-315)translate(-47.071068 -36.071068)"
            points="44.3 38.8 44.3 31.1 42.1 31.1 42.1 40 42.1 41.1 52.1 41.1 52.1 38.8"></polygon>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'ArrowIcon',
    props: {
      direction: String,
      fillColor: {
        type: String,
        default: ''
      }
    },
    computed: {
      classes() {
        return { 'messenger__arrow--right': this.direction === 'right' }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .messenger__arrow {
    margin: 0px auto;
    width: 16px;
    height: 16px;

    &--left {
      //transform: rotate(180deg);
    }

    &--right {
      transform: rotate(180deg);
    }

    g {
      fill: var(--color)
    }

  }

</style>